import { useEffect } from 'react';

let lockCount = 0;

/**
 * Increments modal lock count and ensures document.body has overflow: hidden
 */
export const lockBodyScroll = (): (() => void) => {
  lockCount++;
  if (typeof document !== 'undefined') {
    document.body.style.overflow = 'hidden';
  }
  return () => {
    unlockBodyScroll();
  };
};

/**
 * Decrements modal lock count. When no modals are open (lockCount === 0), restores body scroll.
 */
export const unlockBodyScroll = (): void => {
  lockCount = Math.max(0, lockCount - 1);
  if (typeof document !== 'undefined' && lockCount === 0) {
    document.body.style.overflow = '';
  }
};

/**
 * Force unlock body scroll unconditionally (safety fallback)
 */
export const forceUnlockBodyScroll = (): void => {
  lockCount = 0;
  if (typeof document !== 'undefined') {
    document.body.style.overflow = '';
  }
};

/**
 * React hook that manages body scroll locking based on modal open state.
 * Safely handles nested modals, transitions, and unmounts without freezing the page.
 */
export const useBodyScrollLock = (isLocked: boolean): void => {
  useEffect(() => {
    if (!isLocked) return;
    const unlock = lockBodyScroll();
    return () => {
      unlock();
    };
  }, [isLocked]);
};
